import {IQuery} from '../models'
import {Geometry} from '../../models'

export enum ControlType {
  MultiSelect,
  Autocomplete,
  StringInput,
  NumberInput,
  TimeSpan,
  EnumSelect
}

export enum QueryTarget {
  Data = 1,
  Map = 2
}

export interface IControlQuery extends IRawQuery {
  controlType: ControlType
  controlValue: any
  readonly?: boolean
}

export interface IControlQueries {
  [key: string]: IControlQuery // the field key
}

export interface IRawQuery extends IQuery {
  queryTarget: QueryTarget
}

export interface IRawQueries {
  [key: string]: IRawQuery // the field key
}

export interface IGeometryQuery {
  geometry: Geometry
  queryTarget: QueryTarget
}

export interface IDataQuery {
  controledQueries: IControlQueries
  rawQueries: IRawQueries
  dataWhere?: string
  mapDataWhere?: string
  geometryQuery?: IGeometryQuery
}

export interface IDataQueries {
  [key: string]: IDataQuery // the source key
}
